export default "__VITE_ASSET__835688f4__"